
const projectUri = {
	default: 'projects',
	new: 'projects/new',
	loadContentByTabName: 'projects/:id/:propertyid/load-tab/:tab',
	detail: 'projects/:id',
	searchUnits: 'projects/search-units',
	fianceSearchLinkedUnits: 'projects/:projectId/units',
	projectPreview: 'projects/:id/preview',
	getProjectTabViewMode: "projects/:id/:propertyid/load-tab-in-preview/:tab",
	poiObject: 'projects/:id/poi-object',
	copyToUnits: 'projects/:projectId/copy-to-units',
	loadUnitsByBuildingId: 'projects/:projectId/units?buildingId=:buildingId',
};
export default projectUri;